import EditablePropsType from '../../../types/composer';
import { TEXT_COLOR_OPTIONS } from '../../../constants/composer';
import { fontSizeSchema } from './font';

export const headingSchema = {
  type: EditablePropsType.Text,
  label: 'Heading',
  name: 'heading',
};

export const headingAlignmentSchema = {
  type: EditablePropsType.Select,
  label: 'Heading Alignment',
  name: 'headingAlignment',
  selectOptions: {
    options: [
      { value: 'center', label: 'Center' },
      { value: 'left', label: 'Left' },
      { value: 'right', label: 'Right' },
    ],
  },
};

export const headingTextColorSchema = {
  type: EditablePropsType.Select,
  label: 'Heading Text Color',
  name: 'headingTextColor',
  selectOptions: {
    options: TEXT_COLOR_OPTIONS,
  },
};

export const headingFontSizeSchema = {
  ...fontSizeSchema,
  name: 'headingFontSize',
  label: 'Heading Font Size',
};

export default headingSchema;
